import { atom } from 'jotai'

export type PortfolioDrawerView =
  | 'overview'
  | 'account'
  | 'wallets'
  | 'manage-wallet'
  | 'manage-account'
  | 'edit-account-name'
  | 'edit-account-email'
  | 'verify-email'
  | 'edit-wallet-name'
  | 'settings'
  | 'settings-autopilot'
  | 'settings-ignored-accounts'
  | 'referrals'

interface ViewState {
  view: PortfolioDrawerView
  metadata?: unknown
  stack: PortfolioDrawerView[]
}

export const portfolioDrawerOpenAtom = atom(false)

export const portfolioDrawerSelectedViewAtom = atom<ViewState>({
  view: 'overview',
  metadata: undefined,
  stack: [],
})

export const portfolioDrawerHideBalancesAtom = atom(false)
